import { apiClient } from "../api/ApiClient";
import type { LoginRequest } from "../models/LoginRequest";
import type { LoginResponse } from "../models/LoginResponse";

class AuthService {
  async login(request: LoginRequest): Promise<LoginResponse> {
    const response = await apiClient.post<LoginResponse>(
      "authentication/Login",
      request,
      {
        busyMessage: "Signing you in...",
      },
    );

    return response.data;
  }
}

export const authService = new AuthService();
